import { useTranslation } from "react-i18next";
import { CheckSquare, Trash2 } from "lucide-react";
import { Button } from "@tabipla/ui";
import { usePackingEditMode } from "./PackingContext";

export function BulkEditActionBar() {
  const { t } = useTranslation();
  const {
    selectedItemIds,
    isToggling,
    isDeleting,
    onSelectAllItems: onSelectAll,
    onDeselectAllItems: onDeselectAll,
    onBulkToggleCheck,
    onBulkDelete,
  } = usePackingEditMode();

  const selectedCount = selectedItemIds.size;

  return (
    <div className="fixed inset-x-0 bottom-20 z-40 border-t bg-background px-4 pb-6 pt-3 shadow-lg lg:bottom-0 lg:pb-4">
      <div className="mx-auto flex max-w-lg flex-col gap-2">
        {/* Top row: selection info and select buttons */}
        <div className="flex items-center justify-between">
          <span className="shrink-0 text-sm font-medium">
            {selectedCount} {t("packing.selected")}
          </span>
          <div className="flex gap-1">
            <Button variant="ghost" size="sm" onClick={onSelectAll}>
              {t("packing.selectAll")}
            </Button>
            <Button variant="ghost" size="sm" onClick={onDeselectAll}>
              {t("packing.deselectAll")}
            </Button>
          </div>
        </div>
        {/* Bottom row: action buttons */}
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            className="flex-1"
            onClick={onBulkToggleCheck}
            disabled={selectedCount === 0 || isToggling}
          >
            <CheckSquare className="mr-1 h-4 w-4" />
            {t("packing.toggleCheck")}
          </Button>
          <Button
            variant="destructive"
            size="sm"
            className="flex-1"
            onClick={onBulkDelete}
            disabled={selectedCount === 0 || isDeleting}
          >
            <Trash2 className="mr-1 h-4 w-4" />
            {t("packing.deleteSelected")}
          </Button>
        </div>
      </div>
    </div>
  );
}
